<template>
  <div class="plan-condition py-4 border-b border-section_border">
    <h2 class="section-title text-lg text-center">
      {{$t('tour_tohoku_title')}}
    </h2>
    <div class="p-4 border-b border-section_border" v-html="$t('tour_tohoku_term')" />
  </div>
</template>

<script>
import Constants from "../constants";

export default {
  methods: {
    back: function () {
      this.$router.push({ path: '/plans' })
    },
    tohoku_maas_url: function () {
      var env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      return Constants.LINK_BASE_URL_LIST[env_key] + '/'
    }
  }
}
</script>
